<mat-toolbar class="footer">
    <span>Copyright © {{currentYear}}
        <img src="assets/CoverMyMeds_Logo_Screens.png" width="100px">
    </span>
</mat-toolbar>